//#region ../icons/dist/html/neutral/chevron.js
const chevronIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" fill=\"none\" aria-hidden=\"true\" viewBox=\"0 0 18 18\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\" d=\"M11.667 9.014 6.364 3.711m0 10.606 5.303-5.303\"/></svg>";
//#endregion
export { chevronIcon };
